import React, { useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../ProductType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface FeatureCardModel {
    key: string;
    logo: string;
    header: string;
    content: string;
    classname: string;
}
const features: FeatureCardModel[] = [
    { key: 'fg48-feature-1', logo: '', header: 'Alternative Flight Arrangements', content: 'Rebooking with different airlines at all airports within 50 miles radius at origin or destination.', classname: '' },
    { key: 'fg48-feature-2', logo: '', header: 'Travel Agent Rebooking Protection', content: 'Up to $1,000* to pay for alternative flight arrangement.', classname: 'small-screen-padding-top' },
    { key: 'fg48-feature-3', logo: '', header: 'Flight Monitoring', content: 'Email and SMS flight delay and cancellation status alerts in real-time.', classname: 'small-screen-padding-top' },
    { key: 'fg48-feature-4', logo: '', header: 'Automated Check-in', content: 'Boarding pass issued for your flight 24-hours before departure.', classname: 'small-screen-padding-top large-screen-padding-top' },
    { key: 'fg48-feature-5', logo: '', header: 'Admin Portal', content: 'A real time dashboard reports traveler activity with powerful search capabilities.', classname: 'small-screen-padding-top large-screen-padding-top' },
    { key: 'fg48-feature-6', logo: '', header: 'API Integration', content: 'Automated integration into your customer experience feeding back into your agents with actionable intelligence.', classname: 'small-screen-padding-top large-screen-padding-top' }
];

const FG48 = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    // const navigate = useNavigate();
    // const gotolink = (link: string) => {
    //     navigate(link);
    // }
    const headerBg: string = '/images/backgrounds/ALEG-Image-Traveler_1.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };

    const cardItems = features.map((card: FeatureCardModel) => {
        let classData = 'col-md-4 feature-card';
        if (card.classname) classData = `${classData} ${card.classname}`;
        return (
            <div key={card.key} className={classData}>
                <div className='feature-card-wrapper'>
                    <div className='logo-wrapper'>
                        <img src='/images/icons/ALEG-Image-Icons-Product_FG48_Airline.svg' alt={card.header} />
                    </div>
                    <div className='content-wrapper'>
                        <div className='content-header text-l2 text-med'>
                            {card.header}
                        </div>
                        <div className='content-text'>
                            {card.content} {card.key === 'fg48-feature-2' && <>
                                *See full <a href='https://flightguard48.com/terms.html' target='_blank' rel='noopener noreferrer' className='text-link'>
                                    Terms, and Conditions
                                </a>
                            </>}
                        </div>
                    </div>
                </div>
            </div>
        );
    });
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit | Product | FlightGuard48&#8482;</title>
                    <meta name='description' content='Additional protection for air travelers in the event of flight cancellations by the airline within 48 hours prior to the flight' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height product-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <div className='product-logo-wrapper'>
                                        <img src='/images/icons/ALEG-FG48-ID-LogoType_Rev.png' alt='Auto Check-in' />
                                    </div>
                                    <p className=''>
                                        Critical service for those that need to get to their destination. Provides additional protection for air travelers in the event of flight cancellations by the airline within 48 hours prior to the flight.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='logo-wrapper' style={{ maxWidth: '350px' }}>
                                        <img src='/images/others/ALEG-Image-Header_DashText.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='feature-2-container container-side-padding container-content-padding'>
                    <div className='container-large-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                {cardItems}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        How OTAs Use FlightGuard48&#169;
                                    </h3>
                                    <p className='no-margin'>
                                        An Online Travel Agency incorporated FlightGuard48&#169; into its booking flow to generate ancillary revenue while adding value to its customers. FlightGuard48&#169; removes the uncertainty of modern travel by delivering flight awareness with consistent, meaningful flight status updates and remediation for changes and cancellations.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-Body-Traveler_2.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 small-screen-padding-top large-screen-padding-top'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-Body-Traveler_3.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 small-screen-padding-top large-screen-padding-top'>
                                    <h3 className='text-med'>
                                        Travel Management Company Use Case
                                    </h3>
                                    <p className='no-margin'>
                                        A Corporate Travel Manager embedded FlightGuard48&#169; into every booking to ensure their key employees - surgeons - receive actionable intelligence about their travel and get to their appointments. From automated check-in to alternative flight arrangements to reassuring communications, FlightGuard48&#169; turns unanticipated disruptions into positive employee experiences.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />

                {/* <div className='faq-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='header-content text-med text-l2'>
                                        More Information
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='faq-outer-wrapper'>
                                        FAQ 1
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='faq-outer-wrapper'>
                                        FAQ 2
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default FG48;